import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Form, { FeatureAuthForm } from 'system/components/feature-auth/form';
import { CommonFeatureAuthCrumbs } from 'system/constants/common-feature-auth-crumbs';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

const FeatureAuthNew = (): React.ReactElement => {
  const insertFeatureAuth = useHttpClient(`${__MANAGEMENT_API_URL__}/tipo-feature-auth`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const navigate = useNavigate();

  const onSubmit = (form: FeatureAuthForm | undefined) => {
    (
      insertFeatureAuth({
        data: {
          descrizioneTipoFeature: form?.description || undefined,
          key: {
            codiceFeature: Number.parseInt(form?.code || '', 10),
          },
          note: form?.contextLastUpdate || undefined,
          featureValoreList: form?.valuesFeatureAuth?.body.map((item) => {
            return {
              key: {
                codiceFeature: Number.parseInt(form?.code || '', 0),
                valoreAmmesso: item.value || undefined,
              },
              descrizioneValoreAmmesso: item.description || undefined,
            };
          }),
        },
      }) as ResponsePromise<void, void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/feature-auth');
    });
  };

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonFeatureAuthCrumbs, { name: 'Nuova Autorizzazione' }]} />
      <Form
        title="Nuova Autorizzazione"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/feature-auth');
        }}
        redirectPath="feature-auth/nuovo"
      />
    </Fragment>
  );
};

FeatureAuthNew.displayName = 'Feature Auth new page component';

export default FeatureAuthNew;
